import { api } from '../api/apiCore';

export function verifyUserPassword(data) {
	const url = `/users/verify_password`
	const form = new FormData()
	form.append('password', data.password)

	return api.postForm(url, form);
}

export function loginUser(data) {
	const form = new FormData()
	form.append('email', data.email)
	form.append('password', data.password)

	return api.postForm(`/auth/login`, form)
}

export function refreshAuthToken(data) {
	const form = new FormData();
	for (let key in data) {
		form.append(key, data[key])
	}

	return api.postForm(`/auth/renew`, form)
}

export function logoutUser() {
	const url = `/auth/logout`;

	return api.postForm(url)
}

export function restorePassword(data) {
	const url = `/auth/reset_password`;
	const form = new FormData();
	form.append('email', data.email);

	return api.postForm(url, form);
}

export function changePassword(data) {
	const url = `/reset/${data.token}`;
	const form = new FormData();
	form.append('password', data.password);
	form.append('password_confirm', data.password_confirm);

	return api.postForm(url, form);
}

export function updateUserAccount (state, user_role) {
	let url;

	switch (user_role) {
	case 'system_admin':
		url = `/system_admin/users/${state.email}`;
		break;
	case 'customer_service':
		url = `/customer_service/users/${state.email}`;
		break;
	case 'custom_partner':
	case 'partner':
		url = `/partners/users/${state.email}`;
		break;
	case 'fleet_maintainer':
	case 'fleet_manager':
	case 'storage_manager':
	case 'custom_user':
	case 'user':
		url = `/users/${state.email}`;
		break;
	case 'group_manager':
		url = `/group_manager/users/${state.email}`;
		break;
	default:
		break;
	}

	const form = new FormData();
	if (state.last_name) {form.append('last_name', state.last_name);}
	if (state.first_name) {form.append('first_name', state.first_name);}
	if (state.hasOwnProperty('phone_number')) {form.append('phone_number', state.phone_number);}
	if (state.hasOwnProperty('speed_unit')) {form.append('speed_unit', state.speed_unit);}
	if (state.hasOwnProperty('viewed_thank_you')) {form.append('viewed_thank_you', state.viewed_thank_you);}

	return api.postForm(url, form);
}

export function changePasswordUserAccount (state) {
	const url = `/auth/change_password`;
	const form = new FormData();
	form.append('old_password', state.password);
	form.append('new_password', state.new_password);
	form.append('new_password_confirm', state.new_password_confirm);

	return api.postForm(url, form);
}

export function saveDashboardData(data) {
	const url = `/users/settings`;
	const form = new FormData();
	form.append('dashboard_data', data);

	return api.putForm(url, form);
}

export function getDashboardData() {
	const url = `/users/settings`;

	return api.get(url)
}

export function saveSettings (state) {
	const url = `/users/settings`;
	const form = new FormData();
	if (state.latitude) {form.append('latitude', state.latitude);}
	if (state.longitude) {form.append('longitude', state.longitude);}
	if (state['time_zone'] != undefined) {form.append('time_zone', state.time_zone);}
	if (state.zoom_level) {form.append('zoom_level', state.zoom_level);}

	if (state.inputsensor1_active || state.inputsensor2_active || state.inputsensor3_active || state.inputsensor4_active) {
		form.append('inputsensor1_active', state.inputsensor1_active || null);
		form.append('inputsensor1_name', state.inputsensor1_name || null);
		form.append('inputsensor1_description', state.inputsensor1_description || null);
		form.append('inputsensor2_active', state.inputsensor2_active || null);
		form.append('inputsensor2_name', state.inputsensor2_name || null);
		form.append('inputsensor2_description', state.inputsensor2_description || null);
		form.append('inputsensor3_active', state.inputsensor3_active || null);
		form.append('inputsensor3_name', state.inputsensor3_name || null);
		form.append('inputsensor3_description', state.inputsensor3_description || null);
		form.append('inputsensor4_active', state.inputsensor4_active || null);
		form.append('inputsensor4_name', state.inputsensor4_name || null);
		form.append('inputsensor4_description', state.inputsensor4_description || null);
	}

	return api.putForm(url, form);
}

export function getDynamicDataTop(user_role, start_date, end_date, events, alerts, company_name=null, partner_name=null) {
	// FWSD-6937, if we send alerts in this request then API returnds just data from event_stats_day table otherwise from event_tb table
	let url;
	switch (user_role) {
	case 'system_admin':
		url = `/system_admin/partner/${partner_name}/companies/${company_name}/reports/events?start_ts=${start_date}&end_ts=${end_date}&events=${events}&type=bottom`;
		break;
	case 'customer_service':
		url = `/customer_service/partner/${partner_name}/companies/${company_name}/reports/events?start_ts=${start_date}&end_ts=${end_date}&events=${events}&type=bottom`;
		break;
	case 'partner':
	case 'custom_partner':
		url = `/partners/companies/${company_name}/reports/events?start_ts=${start_date}&end_ts=${end_date}&events=${events}&type=bottom`;
		break;
	case 'partner_view':
		url = `/partner_view/companies/${company_name}/reports/events?start_ts=${start_date}&end_ts=${end_date}&events=${events}&type=bottom`;
		break;
	case 'sales_demo':
		url = `/sales_demo/partner/${partner_name}/companies/${company_name}/reports/events?start_ts=${start_date}&end_ts=${end_date}&events=${events}&type=bottom`;
		break;
	case 'fleet_maintainer':
	case 'fleet_manager':
	case 'group_manager':
	case 'user':
	case 'storage_manager':
	case 'storage_user':
	case 'custom_user':
		url = `/reports/events?start_ts=${start_date}&end_ts=${end_date}&events=${events}&type=bottom`;
		break;
	default:
		break;
	}

	if (alerts.length) {
		url += `&alerts=${alerts}`
	}

	return api.get(url)
}

export function getDynamicDataBottom(user_role, start_date, end_date, events, alerts, company_name=null, partner_name=null) {
	// FWSD-6937, if we send alerts in this request then API returnds just data from event_stats_day table otherwise from event_tb table
	let url;
	switch (user_role) {
	case 'system_admin':
		url = `/system_admin/partner/${partner_name}/companies/${company_name}/reports/events?start_ts=${start_date}&end_ts=${end_date}&events=${events}&type=top`;
		break;
	case 'customer_service':
		url = `/customer_service/partner/${partner_name}/companies/${company_name}/reports/events?start_ts=${start_date}&end_ts=${end_date}&events=${events}&type=top`;
		break;
	case 'partner':
	case 'custom_partner':
		url = `/partners/companies/${company_name}/reports/events?start_ts=${start_date}&end_ts=${end_date}&events=${events}&type=top`;
		break;
	case 'partner_view':
		url = `/partner_view/companies/${company_name}/reports/events?start_ts=${start_date}&end_ts=${end_date}&events=${events}&type=top`;
		break;
	case 'sales_demo':
		url = `/sales_demo/partner/${partner_name}/companies/${company_name}/reports/events?start_ts=${start_date}&end_ts=${end_date}&events=${events}&type=top`;
		break;
	case 'fleet_maintainer':
	case 'fleet_manager':
	case 'group_manager':
	case 'user':
	case 'storage_manager':
	case 'storage_user':
	case 'custom_user':
		url = `/reports/events?start_ts=${start_date}&end_ts=${end_date}&events=${events}&type=top`;
		break;
	default:
		break;
	}

	if (alerts.length) {
		url += `&alerts=${alerts}`
	}

	return api.get(url)
}

export function getDynamicDataDevices(user_role, start_date, end_date, events, alerts, devices, company_name=null, partner_name=null) {
	// FWSD-6937, if we send alerts in this request then API returnds just data from event_stats_day table otherwise from event_tb table
	let url;
	switch (user_role) {
		case 'system_admin':
			url = `/system_admin/partner/${partner_name}/companies/${company_name}/reports/events?start_ts=${start_date}&end_ts=${end_date}&events=${events}&device_ids=${devices}`;
			break;
		case 'customer_service':
			url = `/customer_service/partner/${partner_name}/companies/${company_name}/reports/events?start_ts=${start_date}&end_ts=${end_date}&events=${events}&device_ids=${devices}`;
			break;
		case 'partner':
		case 'custom_partner':
			url = `/partners/companies/${company_name}/reports/events?start_ts=${start_date}&end_ts=${end_date}&events=${events}&device_ids=${devices}`;
			break;
		case 'partner_view':
			url = `/partner_view/companies/${company_name}/reports/events?start_ts=${start_date}&end_ts=${end_date}&events=${events}&device_ids=${devices}`;
			break;
		case 'sales_demo':
			url = `/sales_demo/partner/${partner_name}/companies/${company_name}/reports/events?start_ts=${start_date}&end_ts=${end_date}&events=${events}&device_ids=${devices}`;
			break;
		case 'fleet_maintainer':
		case 'fleet_manager':
		case 'group_manager':
		case 'user':
		case 'storage_manager':
		case 'storage_user':
		case 'custom_user':
			url = `/reports/events?start_ts=${start_date}&end_ts=${end_date}&events=${events}&device_ids=${devices}`;
			break;
		default:
			break;
	}

	if (alerts.length) {
		url += `&alerts=${alerts}`
	}

	return api.get(url)
}

export function getReportFirmware(user_role, company_name=null, partner_name=null) {
	let url;
	switch (user_role) {
	case 'system_admin':
		url = `/system_admin/partner/${partner_name}/companies/${company_name}/reports/firmware`;
		break;
	case 'customer_service':
		url = `/customer_service/partner/${partner_name}/companies/${company_name}/reports/firmware`;
		break;
	case 'partner':
	case 'custom_partner':
		url = `/partners/companies/${company_name}/reports/firmware`;
		break;
	case 'partner_view':
		url = `/partner_view/companies/${company_name}/reports/firmware`;
		break;
	case 'sales_demo':
		url = `/sales_demo/partner/${partner_name}/companies/${company_name}/reports/firmware`;
		break;
	case 'fleet_maintainer':
	case 'fleet_manager':
	case 'group_manager':
	case 'user':
	case 'storage_manager':
	case 'storage_user':
	case 'custom_user':
		url = `/reports/firmware`;
		break;
	default:
		break;
	}

	return api.get(url)
}

export function signupImport(data) {
	const url = `/import/signup`;
	const form = new FormData();
	form.append('user_login', data.user_login);
	form.append('user_password', data.user_password);
	form.append('fleet_token_r2', data.fleet_token_r2);
	form.append('fleet_token_r1', data.fleet_token_r1);

	return api.postForm(url, form);
}

export function checkImportStatus(token) {
	const url = `/import/check?fleet_token_r2=${token}`;

	return api.get(url)
}

export function getUserPermissions(data) {
	const url = `/users/${data.user_id}/permissions`

	return api.get(url)
}


export function updateUserPermissions(data) {
	let url;
	switch (data.user_role) {
		case 'system_admin':
		case 'customer_service':
		case 'fleet_manager':
		case 'partner':
		case 'custom_partner':
			url = `/users/${data.user_id}/permissions`
			break
		default:
			break
	}

	const form = new FormData();
	form.append('permissions', data.permissions);

	return api.postForm(url, form);
}

export function getUserNotifications(email, user_role = null) {
	let url;
	if (user_role === 'partner') {
		url = `/partners/users/${email}?show_notifications=true`
	} else {
		url = `/users/${email}?show_notifications=true`
	}

	return api.get(url)
}

export function updateUserNotifications(email, data) {
	const url = `/users/updatenotifications/${email}`
	const form = new FormData()

	for (let notif of Object.keys(data)) {
		form.append(notif, JSON.stringify(data[notif]))
	}

	return api.postForm(url, form);
}

export function addTutorialVideo(data) {
	const url = `/tutorials`
	const form = new FormData();
	form.append('url', data.url);
	form.append('name', data.name);

	return api.putForm(url, form);
}

export function deleteTutorialVideo(id) {
	const url = `/tutorials/${id}`;

	return api.delete(url);
}

export function confirmResetPassword (data) {
	let url = `/auth/confirm_reset_password`;

	const form = new FormData();
	for (let key in data) {
		form.append(key, data[key])
	}

	return api.postForm(url, form);
}

export function changeUserPasswordOld (data) {
	const { token } = data;
	const url = `/change_password/token/${token}`;

	const form = new FormData();
	for (let key in data) {
		form.append(key, data[key])
	}

	return api.postForm(url, form);
}

export function setMapTypeUsing(data) {
	const url = `/users/map-type-using`;

	const form = new FormData();
	for (let key in data) {
		form.append(key, data[key])
	}

	return api.postForm(url, form);
}
